import { createPinia, defineStore } from 'ui.vue3.pinia'
import './application.css'

// инициализируем Pinia
const store = createPinia();

// создаем хранилище
const catalogStore = defineStore('catalogStore', {
  state: () => ({
    controlsInstance: null,
    contentContainer: null,
    productsCountContainer: null,

    filter: {},
    originFilter: {},
    filterUrl: '',
    delUrl: '',

    productsCount: 0,
    contentBodyHtml: '',

    sort: [],

    view: [],
    htmlWidth: 0,
    viewType: 'L',
    viewSelectedXmlIdValue: null,

    mainStackSvgUrl: '',

    isMobile: false,
    originMobileFilter: {},
    isMobileFilterApplied: false,

    requestTimeoutId: null,
    requestTimeoutDelayDesktop: 2000,
    requestTimeoutDelayMobile: 2000,

    isLoading: false,
    error: null,
  }),
  getters: {
    sortSelectedXmlId() {
      const selectedItem = this.sort.find(item => item.selected === true);
      return selectedItem.xmlId;
    },
    viewSelectedXmlId() {
      if (!this.viewSelectedXmlIdValue) {
        this.viewSelectedXmlIdValue = localStorage.getItem('viewSelectedXmlIdValue');
      }
      return this.viewSelectedXmlIdValue;
    },
    getViews() {
      if (!this.view.length) {
        return null;
      }
      let views = this.view?.filter(item => item.view === this.viewType);
      if (!views.find(item => item.xmlId === this.viewSelectedXmlId)) {
        this.viewSelectedXmlIdValue = views.find(item => item.default).xmlId;
      }
      this.view.forEach((e) => e.selected = e.xmlId === this.viewSelectedXmlId);
      return views;
    },
    isFilterChanged() {
      if (!this.isMobile || !this.originMobileFilter || Object.keys(this.originMobileFilter).length === 0) {
        return false;
      }
      return JSON.stringify(this.filter) !== JSON.stringify(this.originMobileFilter);
    },
  },
  actions: {
    /** Задать ширину видимой области экрана */
    changeWidth(width) {
      this.htmlWidth = width
      let viewType = 'XS';
      if (width >= 400) {
        viewType = 'S';
      }
      if (width >= 600) {
        viewType = 'M';
      }
      if (width >= 768) {
        viewType = 'L';
      }
      this.viewType = viewType;
      this.applyViewValue()
    },
    // Алиас для внешних скриптов (case-insensitive)
    changewidth(width) { this.changeWidth(width); },

    /** Включить мобильный фильтр */
    openMobileFilter() {
      this.isMobile = true
      this.isMobileFilterApplied = false;
      this.originMobileFilter = JSON.parse(JSON.stringify(this.filter));
    },

    /** Применить мобильный фильтр */
    applyMobileFilter(e) {
      this.showContentBody();
      this.originMobileFilter = {};
      this.isMobile = false;
      this.isMobileFilterApplied = false;
      document.querySelector('.menu-popup--filters.is-show')?.classList.remove('is-show');
    },

    /** Закрыть мобильный фильтр */
    closeMobileFilter(reset) {
      if (reset === true) {
        this._clearFilter();
      } else {
        this.filter = this.originMobileFilter;
        this.originMobileFilter = {};
      }
      this.isMobile = false;
      this.isMobileFilterApplied = false;
    },

    resetMobileFilter() {
      this.isMobileFilterApplied = false;
      this._clearFilter();
    },

    /** Сбросить таймаут отправки формы */
    clearRequestTimeout() {
      // подождать планирование таймаута запроса для прочих действий формы при потере фокуса,
      // затем собственно снять таймаут при получении фокуса.
      // Без таймаута будут гонки и непредсказуемый порядок выполнения потери фокуса и получения фокуса
      setTimeout(this._clearRequestTimeout,50);
    },

    /** Сбросить таймаут отправки формы */
    _clearRequestTimeout() {
      if (this.requestTimeoutId) {
        clearTimeout(this.requestTimeoutId);
        this.requestTimeoutId = null;
      }
    },

    /** Установка значения сортировки */
    setSortItem(selectedItem) {
      let oldSelectedItem = this.sort.find(item => item.selected === true);
      if (oldSelectedItem !== selectedItem) {
        if (oldSelectedItem) {
          oldSelectedItem.selected = false;
        }
        selectedItem.selected = true;
        this._clearRequestTimeout();
        let self = this;
        BX.ajax.runAction('wl:norveg.Catalog.setCatalogSectionSort', {
          data: {
            sortXmlId: this.sortSelectedXmlId,
          },
        }).then(
          function (response) {
            self.processRequest();
          },
          function (response) {}
        );
      }
    },

    getImage (hash, s) {
      return `<svg class="icon" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}"><use xlink:href="${this.mainStackSvgUrl}#${hash}"></use></svg>`;
    },

    getClasses (item) {
      let classes = [];
      if (item.checked === 1)
        classes.push('is-active')
      if (this.isLoading)
        classes.push('is-disabled')
      return classes.join(' ');
    },

    /** Установка вида каталога */
    setViewValue(xmlId) {
      this.viewSelectedXmlIdValue = xmlId;
      localStorage.setItem('viewSelectedXmlIdValue', this.viewSelectedXmlIdValue)
      let item = this.view?.filter(item => item.xmlId === xmlId)
      localStorage.setItem('viewSelectedClass', item[0].class)
      this.applyViewValue()
    },

    /** Применение вида каталога */
    applyViewValue() {
      let elementClassList = document.querySelector('[data-section-list]')?.classList
      if (!elementClassList) {
        return
      }
      this.getViews?.forEach(item => {
        if (item.selected) {
          elementClassList.add(item.class)
        } else {
          elementClassList.remove(item.class)
        }
      });
    },

    /** Клик по ссылке со сменой состояния или изменение состояния чекбокса */
    setClickValue(event) {
      event.preventDefault();
      const clickElement = event.target.closest('[data-name]');
      const eventState = this.filter[clickElement.dataset.name];
      const arStateValues = eventState.values ? Object.values(eventState.values) : [];
      const eventStateId = clickElement.dataset.value ?? clickElement.name;
      const obj = arStateValues.find(value => value.id === eventStateId);
      obj.checked = 1 - obj.checked;

      this.scheduleRequest();
    },

    /** Планирование запроса к фильтру и содержимому catalog.section */
    scheduleRequest() {
      if (this.isMobile) return;
      this._clearRequestTimeout();
      this.requestTimeoutId = setTimeout(
        () => {
          this._clearRequestTimeout();
          if (!this._deepEqual(this.filter, this.originFilter)) {
            this.processRequest();
          }
        },
        this.requestTimeoutDelayDesktop
      );
    },

    /** Обработка запроса к фильтру и содержимому catalog.section */
    processRequest() {
      this.isLoading = true;
      let requestObj = this._getRequestObject();
      let searchParams = new URLSearchParams(requestObj);
      let url = new URL(this.filterUrl, window.location.origin);
      const currentPageParams = new URLSearchParams(window.location.search);
      const searchQuery = currentPageParams.get('q');

      if (searchQuery) {
        searchParams.set('q', searchQuery);
      }

      url.searchParams.forEach((value, key) => {
        if (!searchParams.get(key)) {
          searchParams.set(key, value);
        }
      });
      let filterUrl = url.pathname + '?' + searchParams.toString();
      let self = this
      BX.ajax ({
        url: filterUrl,
        method: 'GET',
        dataType: 'json',
        timeout: 30,
        async: true,
        processData: true,
        scriptsRunFirst: false,
        emulateOnload: false,
        start: true,
        cache: true,
        onsuccess: function(data) {
          self.applyData(data);
          self.error = null;
        },
        onfailure: function(error){
          self.error = 'Failed to fetch data.';
          self.isLoading = false;
        }
      })
    },

    /** Сброс фильтра и перезагрузка контента catalog.section */
    _clearFilter() {
      this.isLoading = true;
      let searchParams = new URLSearchParams ({
        set_filter: 'Y',
        FILTER_URL: this.delUrl,
      });
      let url = new URL(this.delUrl, window.location.origin);
      url.searchParams.forEach((value, key) => {
        if (!searchParams.get(key)) {
          searchParams.set(key, value);
        }
      });
      let filterUrl = url.pathname + '?' + searchParams.toString();
      let self = this
      BX.ajax ({
        url: filterUrl,
        method: 'GET',
        dataType: 'json',
        timeout: 30,
        async: true,
        processData: true,
        scriptsRunFirst: false,
        emulateOnload: false,
        start: true,
        cache: true,
        onsuccess: function(data) {
          self.applyData(data);
          self.error = null;
        },
        onfailure: function(error){
          self.error = 'Failed to fetch data.';
          self.isLoading = false;
        }
      })
    },

    /** Получение списка значений фильтра по типу */
    _getFilterValuesOfType (allowedTypes) {
      const regex = new RegExp('^['+ allowedTypes + ']{1}$');
      return Object
        .values(this.filter)                    // получаем массив значений вместо свойств из объекта this.filter
        .filter(e => regex.test(e.type))        // фильтр значений по типу свойства согласно regex
        .map(e => e.values)                     // возвращаем у каждого значения свойства объект опций
        .flatMap(e => Object.values(e));// из массива объектов опций формируем суммарный плоский массив опций
    },

    /** Объект запроса для построения секций каталога с применением фильтра */
    _getRequestObject () {
      let requestObj = {
        set_filter: 'Y',
        FILTER_URL: this.filterUrl,
      };
      this._getFilterValuesOfType('SLE').forEach((item) => {
        if (item.checked) {
          requestObj[item.id] = 'Y';
        }
      });
      this._getFilterValuesOfType('N').forEach((item) => {
        requestObj[item.id] = item.htmlValue;
      });
      return requestObj;
    },

    _deepEqual (obj1, obj2) {
      // Сравнение примитивов и null/undefined
      if (obj1 === obj2) return true

      // Проверка на типы объектов
      if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false

      // Получаем ключи объектов
      const keys1 = Object.keys(obj1)
      const keys2 = Object.keys(obj2)

      // Проверка количества ключей
      if (keys1.length !== keys2.length) return false

      // Рекурсивное сравнение каждого свойства
      for (const key of keys1) {
        if (!keys2.includes(key) || !this._deepEqual(obj1[key], obj2[key])) return false
      }

      return true
    },

    showContentBody() {
      if (this.contentBodyHtml) {
        const uri = new BX.Uri(window.top.location.toString());
        if (uri.getPath() !== '/') {
          uri.setPath(this.filterUrl);
          window.top.history.replaceState({}, document.title, uri.toString());
        }
        this.contentContainer.innerHTML = this.contentBodyHtml;
        this.controlsInstance.reinitShowMoreButton()
      }
    },

    applyData(data) {
      this.isLoading = true;

      // console.log(data)
      this.filterUrl = data.filter.filterUrl;
      this.delUrl = data.filter.delUrl;
      this.requestTimeoutDelayDesktop = data.filter.timeoutDelayDesktop;
      this.requestTimeoutDelayMobile = data.filter.timeoutDelayMobile;

      this.mainStackSvgUrl = data.filter.mainStackSvgUrl;

      this.sort = data.sort;

      this.view = data.view.sort((a, b) => a.sort - b.sort);
      this.applyViewValue()

      this.originFilter = data.filter.options;
      this.filter = JSON.parse(JSON.stringify(this.originFilter));

      if (this.isMobile) {
        this.isMobileFilterApplied = true;
        this.originMobileFilter = JSON.parse(JSON.stringify(this.filter));
      }

      this.productsCount = data.count;
      this.contentBodyHtml = data.contentBody;

      if (this.productsCountContainer) {
        this.productsCountContainer.innerHTML = this.productsCount;
      }

      if (!this.isMobile) {
        this.showContentBody();
      }

      this.error = null;
      this.isLoading = false;
    },
  },
});

export { store, catalogStore }
